import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { buscarCategoriaTorneioPorId, CategoriaTorneio } from '../../../services/categoriaTorneioService';
import { buscarFaseGrupoPartidasPorFaseCategoriaTorneio, FaseGrupoPartidasLite } from '../../../services/faseGrupoPartidasService';
import { buscarClassificacaoPorGrupo, LinhaClassificacaoFront } from '../../../services/classificacaoService';
import CategoriaPrintPage from '../../../components/tournament/print/CategoriaPrintPage';
import Load from '../../../components/Load';
import Header from '../../../components/Header';
import Appfooter from '../../../components/Appfooter';
import { PageBreadcrumb } from '../../../components/navigation';

const CategoryPrintPage: React.FC = () => {
  const { torneioId, categoriaId } = useParams<{ torneioId: string; categoriaId: string }>();
  const navigate = useNavigate();
  const [categoria, setCategoria] = useState<CategoriaTorneio | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [gruposPorFase, setGruposPorFase] = useState<Map<string, FaseGrupoPartidasLite[]>>(new Map());
  const [classificacaoPorGrupo, setClassificacaoPorGrupo] = useState<Record<string, LinhaClassificacaoFront[]>>({});

  useEffect(() => {
    const loadData = async () => {
      if (!categoriaId) {
        setError('ID da categoria não fornecido');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        // Carregar categoria
        const categoriaData = await buscarCategoriaTorneioPorId(categoriaId);
        setCategoria(categoriaData);

        // Carregar grupos para cada fase GRUPO
        const gruposMap = new Map<string, FaseGrupoPartidasLite[]>();
        const fasesGrupo = categoriaData.fasesCategoria.filter(f => f.tipoGrupoChave === 'GRUPO');

        for (const fase of fasesGrupo) {
          // Bug #4 (code-review): sem catch silencioso — o erro propaga ao handler externo
          // (setError) em vez de renderizar a impressão com dados parciais e sem aviso.
          const grupos = await buscarFaseGrupoPartidasPorFaseCategoriaTorneio(fase.id);
          gruposMap.set(fase.id, grupos);
        }

        setGruposPorFase(gruposMap);

        // Carregar a classificação oficial (MotorClassificacao) de cada grupo, para a
        // impressão exibir a MESMA ordem/contagem da gestão (sem recálculo client-side).
        const classificacaoMap: Record<string, LinhaClassificacaoFront[]> = {};
        for (const fase of fasesGrupo) {
          const grupos = gruposMap.get(fase.id) || [];
          await Promise.all(
            grupos.map(async grupo => {
              // Bug #4 (code-review): sem catch silencioso — o erro propaga ao handler externo.
              classificacaoMap[grupo.id] = await buscarClassificacaoPorGrupo(grupo.id);
            })
          );
        }
        setClassificacaoPorGrupo(classificacaoMap);
      } catch (err: any) {
        setError(err.message || 'Erro ao carregar dados para impressão');
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [categoriaId]);

  // Disparar impressão quando dados estiverem carregados
  useEffect(() => {
    if (!loading && categoria && gruposPorFase.size >= 0) {
      // Pequeno delay para garantir que o DOM está renderizado
      const timer = setTimeout(() => {
        window.print();
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [loading, categoria, gruposPorFase]);

  if (loading) {
    return (
      <>
        <Header />
        <div className="main-content right-chat-active">
          <div className="middle-sidebar-bottom">
            <div className="middle-sidebar-left">
              <div className="row feed-body">
                <div className="col-xl-12">
                  <Load />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Appfooter />
      </>
    );
  }

  if (error || !categoria) {
    return (
      <>
        <Header />
        <div className="main-content right-chat-active">
          <div className="middle-sidebar-bottom">
            <div className="middle-sidebar-left">
              <div className="row feed-body">
                <div className="col-xl-12">
                  <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3 mt-3">
                    <div className="card-body p-4">
                      <div className="alert alert-danger" role="alert">
                        <h5 className="alert-heading">Erro</h5>
                        <p className="mb-0">{error || 'Erro ao carregar dados para impressão'}</p>
                      </div>
                      <button
                        className="btn btn-primary mt-3"
                        onClick={() => navigate(`/liga/tournament/${torneioId}/category/${categoriaId}/manage`)}
                      >
                        Voltar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Appfooter />
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="main-content right-chat-active">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left">
            <div className="row feed-body">
              <div className="col-xl-12">
                <div className="no-print mb-3">
                  <PageBreadcrumb
                    items={[
                      { label: 'Dashboard', href: '/liga/dashboard' },
                      { label: 'Torneios', href: '/liga/tournaments' },
                      {
                        label: categoria?.torneio?.nome ?? 'Torneio',
                        href: `/liga/tournament/${torneioId}`,
                      },
                      {
                        label: categoria?.nome ?? 'Categoria',
                        href: `/liga/tournament/${torneioId}/category/${categoriaId}/manage`,
                      },
                      { label: 'Imprimir' },
                    ]}
                    onBack={() =>
                      navigate(`/liga/tournament/${torneioId}/category/${categoriaId}/manage?tab=2`)
                    }
                    variant="bootstrap"
                  />
                  <button
                    className="btn btn-primary mt-2"
                    onClick={() => window.print()}
                  >
                    Imprimir
                  </button>
                </div>
                <CategoriaPrintPage
                  categoria={categoria}
                  gruposPorFase={gruposPorFase}
                  classificacaoPorGrupo={classificacaoPorGrupo}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Appfooter />
    </>
  );
};

export default CategoryPrintPage;










